<template>
    <div>
        <notifications></notifications>

        <navbar :show-navbar="showMenu" type="white" :transparent="false">
          
          <div class="navbar-wrapper">
            <div class="navbar-toggle" :class="{toggled: showMenu}">
              <navbar-toggle-button @click.native="toggleNavbar">
              </navbar-toggle-button>
            </div>
            <a class="navbar-brand mx-auto" href="/">
              <img src="https://kjc.sgp1.digitaloceanspaces.com/misc/Blue-01.png" alt="kristu-jayanti-logo">
            </a>
          </div>

          <template slot="navbar-menu">
            <a class="navbar-brand mx-auto" href="/www/glimpses">
              <img src="https://kjc.sgp1.digitaloceanspaces.com/misc/glimpses-logo.png" alt="kristu-jayanti-logo">
            </a>
          </template>
            
        </navbar>

        <div class="wrapper wrapper-full-page">
            <div class="full-page" :class="pageClass">

                <div class="content">
                    <div class="container-fluid">
                    <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
                        <router-view></router-view>
                    </zoom-center-transition>
                    </div>
                </div>

                <footer class="footer">
                    <div class="container-fluid">
                        <div class="copyright center">
                            Copyright &copy; {{year}} Kristu Jayanti (Deemed to be University) <br>Developed by <a href="http://www.three38inc.com/"><img src="https://kjc.sgp1.digitaloceanspaces.com/misc/Asset%204@4x.png" alt="three38-logo-signature-light" /></a>
                        </div>
                    </div>
                </footer>
            </div>
        </div>

    </div>
</template>
<script>
import { Navbar, NavbarToggleButton } from 'src/components';
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'glimpses-page'
    };
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove('nav-open');
      this.showMenu = false;
    },
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  beforeRouteUpdate(to, from, next) {
    
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route() {
      this.setPageClass();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.footer{
  .copyright{
    float: none;
    width: 100%;

    &.center{
      text-align: center;
    }

    &.right{
      text-align: right;
    }

    &.left{
      text-align: left;
    }

    img{
      max-height: 20px;
      width: auto;
    }
  }
}

.navbar-brand img{
  max-height: 60px;
}

.full-page.single.news-page .content,
.full-page.home.vi-page .content,
.glimpses-page.full-page .content{
  background: #ecf0f1!important;
}

</style>
